import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2BrainIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 50.852 47.505",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47.505),
    children: [/*#__PURE__*/jsx("path", {
      d: "M23.746 14.106a8.037 8.037 0 1111.263 1.62M49.474 17.321a9.645 9.645 0 01-9.645 9.645h-3.215M9.422 20.538h4.687M14.78 26.966a3.215 3.215 0 013.215 3.215v6.43"
    }), /*#__PURE__*/jsx("path", {
      d: "M36.614 46.251V36.61h4.822a8.035 8.035 0 006-13.374 9.634 9.634 0 00-9.349-15.4 8.037 8.037 0 00-15.94 1.448 4.844 4.844 0 00.021.559A9.645 9.645 0 009.422 20.536h-.135a8.037 8.037 0 100 16.074H18a8.037 8.037 0 0012.189 3.215v6.426"
    }), /*#__PURE__*/jsx("path", {
      d: "M30.184 39.825v-6.43a3.215 3.215 0 00-3.215-3.215h-3.215"
    })]
  });
};

export { PM2BrainIcon };
//# sourceMappingURL=brain.js.map
